export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/legal_writing.7b783be.svg";